export const OneKB = 1024
export const OneMB = 1024 * OneKB
